export function isNumeric(str: string) {
  if (typeof str != 'string') return false // we only process strings!

  return !isNaN(Number(str))
}

/**
 * Valid when string is not empty
 */
export function isStringValid(str: string) {
  return str && str.trim().length !== 0
}

export function isLatLngValid(lat: string, lng: string) {
  if (!isNumeric(lat)) return false
  if (!isNumeric(lng)) return false
  const latNum = parseFloat(lat)
  const lngNum = parseFloat(lng)

  if (latNum >= -90 && latNum <= 90) return true
  if (lngNum >= -180 && lngNum <= -180) return true

  return false
}
